import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
    class: "g-search-box__table",
    role: "listbox"
};
const _hoisted_2 = { class: "g-search-box__thead" };
const _hoisted_3 = {
    key: 0,
    class: "g-search-box__th g-search-box__th--icon"
};
const _hoisted_4 = ["data-highlighted", "aria-selected", "onClick"];
const _hoisted_5 = {
    key: 0,
    class: "g-search-box__td g-search-box__td--icon"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
    key: 1,
    class: "g-search-box__tree-leaf-indent"
};
const _hoisted_8 = { key: 0 };
const _hoisted_9 = ["colspan"];
const _hoisted_10 = { key: 1 };
const _hoisted_11 = ["colspan"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("table", _hoisted_1, [
        _createElementVNode("thead", _hoisted_2, [
            _createElementVNode("tr", null, [
                (_ctx.iconField)
                    ? (_openBlock(), _createElementBlock("th", _hoisted_3))
                    : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
                    return (_openBlock(), _createElementBlock("th", {
                        key: col.field,
                        class: "g-search-box__th",
                        style: _normalizeStyle(col.width ? `width: ${col.width}` : undefined)
                    }, _toDisplayString(col.label ?? col.field), 5));
                }), 128))
            ])
        ]),
        _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nodes, (node, idx) => {
                return (_openBlock(), _createElementBlock("tr", {
                    key: String(node.item[_ctx.idField]),
                    class: _normalizeClass(["g-search-box__item", {
                            'g-search-box__item--active': _ctx.isSelected(node.item),
                            'g-search-box__item--branch': node.hasChildren && _ctx.selectLeafOnly,
                            'g-search-box__item--highlighted': idx === _ctx.highlightedIndex,
                        }]),
                    "data-highlighted": idx === _ctx.highlightedIndex ? true : undefined,
                    role: "option",
                    "aria-selected": _ctx.isSelected(node.item),
                    onClick: ($event) => (_ctx.handleRowClick(node))
                }, [
                    (_ctx.iconField)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_5, [
                            (node.item[_ctx.iconField])
                                ? (_openBlock(), _createElementBlock("i", {
                                    key: 0,
                                    class: _normalizeClass(["bi g-search-box__item-icon", String(node.item[_ctx.iconField])])
                                }, null, 2))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col, colIdx) => {
                        return (_openBlock(), _createElementBlock("td", {
                            key: col.field,
                            class: "g-search-box__td",
                            style: _normalizeStyle({
                                width: col.width ?? undefined,
                                paddingLeft: colIdx === 0 ? `${0.4 + node.depth * 1.25}rem` : undefined,
                            })
                        }, [
                            (colIdx === 0 && node.hasChildren)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "g-search-box__tree-toggle",
                                    type: "button",
                                    tabindex: "-1",
                                    onClick: _withModifiers(($event) => (_ctx.$emit('toggle-node', String(node.item[_ctx.idField]))), ["stop"])
                                }, [
                                    _createElementVNode("i", {
                                        class: _normalizeClass(["bi bi-chevron-right g-search-box__tree-chevron", { 'g-search-box__tree-chevron--open': _ctx.isNodeExpanded(String(node.item[_ctx.idField])) }])
                                    }, null, 2)
                                ], 8, _hoisted_6))
                                : (colIdx === 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_7))
                                    : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(node.item[col.field]), 1)
                        ], 4));
                    }), 128))
                ], 10, _hoisted_4));
            }), 128)),
            (!_ctx.isLoading && _ctx.nodes.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                    _createElementVNode("td", {
                        colspan: _ctx.colCount,
                        class: "g-search-box__empty"
                    }, "Keine Ergebnisse", 8, _hoisted_9)
                ]))
                : _createCommentVNode("", true),
            (_ctx.isLoadingMore)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                    _createElementVNode("td", {
                        colspan: _ctx.colCount,
                        class: "g-search-box__loading-more"
                    }, [...(_cache[0] || (_cache[0] = [
                            _createElementVNode("span", {
                                class: "spinner-border spinner-border-sm",
                                role: "status",
                                "aria-label": "Lädt..."
                            }, null, -1)
                        ]))], 8, _hoisted_11)
                ]))
                : _createCommentVNode("", true)
        ])
    ]));
}
